import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'Root/Component/Link'

import styles from './index.module.css'

interface Props {
  anchor?: boolean
  icon?: React.ReactNode
  download?: string
  size?: 'XS' | 'S' | 'M' | 'L'
  [props: string]: any
}

library.add(faPlus)

const DefaultIcon = <FontAwesomeIcon icon={['fas', 'plus']} />

const Circle = ({
  anchor = false,
  icon = DefaultIcon,
  size = 'S',
  download = null,
  ...props
}: Props) => {
  const className = classNames(
    styles.button,
    styles[`size-${size.toLowerCase()}`],
    props.className || styles.default
  )

  if (Boolean(anchor)) {
    return (
      <Link {...props} className={className}>
        <div>{icon}</div>
      </Link>
    )
  }

  if (Boolean(download)) {
    return (
      <a href={props.href} download={download}>
        <button {...props} className={className}>
          <div>{icon}</div>
        </button>
      </a>
    )
  }

  return (
    <button {...props} className={className}>
      <div>{icon}</div>
    </button>
  )
}

export default Circle
